import { EditorStarterItem } from '../item-type';

/**
 * 그룹 이동 delta 를 children 의 left/top 에 전파한 새 items 맵을 반환한다.
 *
 * GroupItem 은 bbox 를 SoT 로 저장하지 않는다(그룹 렌더 위치 = children union bbox,
 * computeGroupGeometry). 그래서 그룹의 left/top 만 바꾸면 children 이 제자리에 남아
 * 카드 실체는 안 움직이고 저장 bbox 기준 아웃라인만 이동한다. change-item/change-items 는
 * 아이템 갱신 직후 이 함수로 그룹 이동 delta 를 children 에 전파해 동기화한다.
 *
 * - updatedItem 이 group 이 아니면 items 를 그대로 반환한다(참조 동일).
 * - 이동 delta(dx,dy)가 0 이면 그대로 반환한다(no-op, 참조 동일).
 * - items 에 없는 childId 는 방어적으로 무시한다.
 * - 그룹 자신은 caller 가 이미 새 left/top 을 반영했으므로 여기서 건드리지 않는다.
 */
export const translateGroupChildren = (
  items: Record<string, EditorStarterItem>,
  prevItem: EditorStarterItem,
  updatedItem: EditorStarterItem,
): Record<string, EditorStarterItem> => {
  if (updatedItem.type !== 'group') return items;

  const dx = updatedItem.left - prevItem.left;
  const dy = updatedItem.top - prevItem.top;
  if (dx === 0 && dy === 0) return items;

  let changed = false;
  let next = items;
  const seen = new Set([updatedItem.id]);
  const visit = (childId: string): void => {
    if (seen.has(childId)) return;
    seen.add(childId);
    const child = items[childId];
    if (!child) return;
    if (!changed) {
      next = { ...items };
      changed = true;
    }
    next[childId] = { ...child, left: child.left + dx, top: child.top + dy };
    if (child.type === 'group') child.children.forEach(visit);
  };
  updatedItem.children.forEach(visit);
  return next;
};
